import { render, staticRenderFns } from "./DeletePatientModal.vue?vue&type=template&id=6e3a7d83&scoped=true"
import script from "./DeletePatientModal.vue?vue&type=script&lang=js"
export * from "./DeletePatientModal.vue?vue&type=script&lang=js"
import style0 from "./DeletePatientModal.vue?vue&type=style&index=0&id=6e3a7d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a7d83",
  null
  
)

export default component.exports